import { render, staticRenderFns } from "./ProductNotifiedModal.vue?vue&type=template&id=7420c46e&scoped=true"
import script from "./ProductNotifiedModal.vue?vue&type=script&lang=js"
export * from "./ProductNotifiedModal.vue?vue&type=script&lang=js"
import style0 from "./ProductNotifiedModal.vue?vue&type=style&index=0&id=7420c46e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7420c46e",
  null
  
)

export default component.exports